/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  LabelValuePair,
  LabelValuePairFromJSON,
  LabelValuePairFromJSONTyped,
  LabelValuePairToJSON,
} from "./";

/**
 *
 * @export
 * @interface Operator
 */
export interface Operator {
  /**
   *
   * @type {string}
   * @memberof Operator
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof Operator
   */
  value: string;
  /**
   *
   * @type {Array<LabelValuePair>}
   * @memberof Operator
   */
  channels: Array<LabelValuePair>;
}

export function OperatorFromJSON(json: any): Operator {
  return OperatorFromJSONTyped(json, false);
}

export function OperatorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Operator {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    label: json["label"],
    value: json["value"],
    channels: (json["channels"] as Array<any>).map(LabelValuePairFromJSON),
  };
}

export function OperatorToJSON(value?: Operator | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    label: value.label,
    value: value.value,
    channels: (value.channels as Array<any>).map(LabelValuePairToJSON),
  };
}
